<template>
  <div class="home">
    <section class="text-center">
      <h1 class="pt-6 mb-4 text-3xl text-gray-800">{{ $t('Welcome to') }} {{ restaurant.name }}!</h1>
      <div v-if="!isLoading" v-for="(category, i) in parsedMenu" :key="i">
        <h2 class="my-4 text-2xl font-bold tracking-wider">{{ category[0] }}</h2>
        <div
          v-for="(item, index) in category[1]"
          :key="index"
          class="relative flex mx-4 mb-6 bg-white rounded-lg shadow-lg"
        >
          <eva-icon
            name="plus-outline"
            animation="pulse"
            width="40"
            height="40"
            fill="#23D25B"
            class="z-10 border-2 rounded-full shadow-lg plus-icon border-app-green"
            @click="handleAddItem(item)"
          ></eva-icon>
          <div
            class="flex-none w-32 h-32 bg-center bg-cover rounded md:h-56 md:w-56"
            :style="`background-image: url('${item.url}')`"
          ></div>
          <div class="w-full pt-4 pl-4 text-left">
            <div class="flex justify-between w-full">
              <h2 class="text-2xl font-bold md:text-3xl">{{ item.name }}</h2>
              <h2 class="mr-4 text-2xl md:text-3xl">${{ item.price.toFixed(2) }}</h2>
            </div>
            <p class="mb-2 mr-16 text-base md:text-xl md:mr-8">{{ item.description }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { db, storage } from '@/firebase';

export default {
  name: 'RestaurantHome',
  async created() {
    this.isLoading = true;
    const { restaurantId } = this.$route.params;
    const restaurant = await db
      .collection('restaurants')
      .doc(restaurantId)
      .get();
    if (restaurant.exists) {
      const { menu, menuCategories, ...rest } = restaurant.data();
      this.restaurant = { ...rest, uid: restaurantId };
      const n = [];
      menu.forEach(async (m, index) => {
        if (m.available) {
          const url = await this.getURL(m);
          n.push({ ...m, url, index });
        }
      });
      this.menu = n;
      this.categories = menuCategories;
      this.isLoading = false;
      // this.getMenuURLS();
    }
    localStorage.setItem('lastRestaurant', restaurantId);
  },
  data() {
    return {
      restaurant: {},
      menu: [],
      categories: [],
    };
  },
  computed: {
    parsedMenu() {
      const cleanMenu = [];
      if (this.categories) {
        this.categories.forEach(c => {
          const tmpMenu = this.menu.filter(menuItem => menuItem.category === c);
          if (tmpMenu.length > 0) cleanMenu.push([c, [...tmpMenu.sort((a, b) => a.index - b.index)]]);
        });
      }
      const others = this.menu.filter(m => !m.category).sort((a, b) => a.index - b.index);
      if (others.length > 0) {
        cleanMenu.push(['Other', others]);
      }
      return cleanMenu;
    },
  },
  methods: {
    async getMenuURLS() {
      for (let index = 0; index < this.menu.length; index += 1) {
        const m = this.menu[index];
        if (m.available) {
          const url = await this.getURL(m);
          this.menu[index].url = url;
        }
      }
    },
    async getURL(item) {
      const { imageRef } = item;
      if (imageRef !== '') {
        let url;
        try {
          const extension = imageRef.substr(imageRef.lastIndexOf('.'));
          const fileName = imageRef.substr(0, imageRef.lastIndexOf('.'));
          url = await storage
            .ref()
            .child(`${fileName}_300x300${extension}`)
            .getDownloadURL();
        } catch (e) {
          url = await storage
            .ref()
            .child(imageRef)
            .getDownloadURL();
        }

        return url;
      }
      const images = require.context('@/assets/', false, /\.jpg$/);
      const productImage = images('./noimage.jpg');
      return productImage;
    },
    handleAddItem(item) {
      this.$store.commit('addToCart', { ...item, restaurant: this.restaurant.uid });
    },
  },
};
</script>
<style lang="scss">
.plus-icon {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
</style>
